import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

export default function (props) {
    return (
        <CircularProgress
            sx={{
                'MuiCircularProgress-root': {
                    color: '#3b4a5d'
                }
            }}
            {...props}
        />
    );
}
